import React from 'react'
import { AiResult } from '../../../../../../../models/AiResult'

import { DefaultResultCardHeaderButtons } from './ResultCardHeaderButtons'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { CUSTOM_PRESET_MAPPING } from '../../../CustomPresets/CustomPresetMapping'
import { TrackEvent, useTracking } from '../../../../common/tracking'
import { getRoomTrackingDetailsForAiResult } from '../../../../tracking'
import { HeaderResultOption } from './HeaderResultOptions/HeaderResultOptionsButton'
import { HeaderResultOptionConfig } from './HeaderResultOptions/DefaultHeaderResultOptions'

export interface ResultCardHeaderProps {
  presetId: string
  name: string
  aiFeature?: AiFeature
  aiResult?: AiResult
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  noResults: boolean
  extraHeaderOptions?: HeaderResultOption[]
  headerResultOptionsConfig?: Partial<HeaderResultOptionConfig>
}

export const ResultCardHeader: React.FC<ResultCardHeaderProps> = ({
  presetId,
  name,
  aiFeature,
  aiResult,
  collapsed,
  setCollapsed,
  noResults,
  extraHeaderOptions,
  headerResultOptionsConfig,
}) => {
  const { tracked } = useTracking()

  const _handleHeaderClicked = () => {
    if (!noResults && !aiResult) {
      return
    }
    setCollapsed(!collapsed)
  }

  const handleHeaderClicked = tracked(
    _handleHeaderClicked,
    {
      eventName: TrackEvent.AI_RESULT_OPENED,
      eventDetails: {
        ...getRoomTrackingDetailsForAiResult(aiResult),
        openMethod: 'single',
      },
    },
    { condition: collapsed },
  )

  const ResultCardHeaderButtonsElement = CUSTOM_PRESET_MAPPING[presetId]?.headerButtons ?? DefaultResultCardHeaderButtons

  return (
    <div className='d-flex zocks-gap-2.5 zocks-pr-1.75 zocks-pl-2.0 align-items-center result-card-header'>
      <div className='d-flex gap-3 flex-grow-1 align-items-center cursor-pointer' onClick={handleHeaderClicked}>
        <h5>{name}</h5>
      </div>
      {aiFeature && aiResult && (
        <div className='result-card-buttons-container'>
          <ResultCardHeaderButtonsElement
            aiFeature={aiFeature}
            aiResult={aiResult}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            noResults={noResults}
            extraHeaderOptions={extraHeaderOptions}
            headerResultOptionsConfig={headerResultOptionsConfig}
          />
        </div>
      )}
    </div>
  )
}
